import { render, staticRenderFns } from "./StripePublishableKey.vue?vue&type=template&id=b745341a&"
import script from "./StripePublishableKey.vue?vue&type=script&lang=ts&"
export * from "./StripePublishableKey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports